import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {push} from 'react-router-redux'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {toggleDropdown, openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalAccount from 'Skelet/src/components/ModalAccount.js'
import StartFooterCTA from '../StartFooterCTA.js'
import StartFooter from 'Skelet/src/components/Start_Footer.js'
import CompanyFooter from 'Skelet/src/components/Company_Footer.js';


class StartRoute extends React.Component {

  constructor(props) {
    super(props);

    let modal_open = false;
    let modal_content = "login";
    let reset_token = null;
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_login = params.get('login');
      let param_reset = params.get('reset');
      let param_verify = params.get('verify'); // this won't be from an e-mail, but might be helpful to manually trigger when bugged.
      if(param_login === "") {
        modal_open = true;
      } else if(param_reset !== null) {
        modal_open = true;
        modal_content = "reset";
        reset_token = params.get('token');
      } else if(param_verify !== null) {
        modal_open = true;
        modal_content = "verify";
      }
    }

    this.state = {modal_open:modal_open, modal_content:modal_content, reset_token:reset_token, is_scrolling:false};
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else if(!this.state.is_scrolling) {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    let linktext_login = "Inloggen";
    let linktext_register = "Start nu GRATIS";
    if(this.props.lang === "EN") {
      linktext_login = "Login";
      linktext_register = "Join for FREE";
    }
    const Header = () => <header className={(this.state.is_scrolling) ? "scrolling" : null}><div className="container wrap wrap-full">{/* @TODO: los component */}
      <div className="primary">
        <Link to="/start" onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo">{config.app_id}</Link>
      </div>
      <div className="secondary">
            <nav className="navigation">
              <ol>
                <li className="md-shown nav-item"><a href="#features" className="btn btn-offset btn-fat">Features</a></li>
                <li className="md-shown nav-item"><a href="#pricing" className="btn btn-offset btn-fat">Pricing</a></li>
                <li className="md-shown nav-item"><a href="#faq" className="btn btn-offset btn-fat">FAQ</a></li>
                {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => openModal(this)} className="btn btn-offset btn-fat">{linktext_login}</button></li>}
                {!this.props.session_token && <li className="md-shown nav-item"><button onClick={() => openModal(this, null, "register")} className="btn btn-c btn-fat">{linktext_register}</button></li>}
                {this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-d btn-fat">Dashboard</button></li>}
                <li className={"md-hidden nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                  <button onClick={() => toggleDropdown(this)} className="btn btn-d btn-fat">menu</button>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul style={{textAlign:"center"}}>
                      <li className="nav-item"><button onClick={() => {toggleDropdown(this);document.getElementById("features").scrollIntoView(true);}} className="btn btn-offset btn-fat">Features</button></li>
                      <li className="nav-item"><button onClick={() => {toggleDropdown(this);document.getElementById("pricing").scrollIntoView(true);}} className="btn btn-offset btn-fat">Pricing</button></li>
                      <li className="nav-item"><button onClick={() => {toggleDropdown(this);document.getElementById("faq").scrollIntoView(true);}} className="btn btn-offset btn-fat">FAQ</button></li>
                      {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this)}} className="btn btn-offset btn-fat">{linktext_login}</button></li>}
                      {!this.props.session_token && <li className="nav-item"><button onClick={() => {toggleDropdown(this);openModal(this, null, "register")}} className="btn btn-c btn-fat">{linktext_register}</button></li>}
                      {this.props.session_token && <li className="md-shown nav-item"><button onClick={() => {document.getElementById("main").scrollIntoView(true);this.props.push("/")}} className="btn btn-d btn-fat">Dashboard</button></li>}
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
    </div></header>;

    let sitemap = {"Start":"/start"};
    if(this.props.lang === "EN") {
      sitemap = {"Start":"/start"};
    }

    return (
      <div>
        <div className="start">
        <ModalAccount shouldShow={this.state.modal_open} close={() => closeModal(this)} modal_content={this.state.modal_content} reset_token={this.state.reset_token} config={config} />
          <main>
            <Header />
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              openModal: (modal_content) => openModal(this, null, modal_content),
              config,
              session_token: this.props.session_token
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          <StartFooterCTA openModal={() => openModal(this, null, "register")} logged_in={!!this.props.session_token} />
          </main>
          <CompanyFooter lang={this.props.lang} site={config.app_id} sitemap={sitemap} />
          <StartFooter lang={this.props.lang} />
        </div>
      </div>
    );
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    // pathname: ownProps.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js